import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const navLinks = [
  { label: 'SrWithアカデミーとは', href: '/lp/academy' },
  { label: 'セミナー', href: '/lp/academy/seminar' },
  { label: '料金', href: '/lp/academy#price' },
  { label: '事例', href: '/lp/academy#cases' },
];

const AcademyHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-lp-charcoal border-b border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center pt-1 pb-3 md:py-3 relative">
          {/* 左側ナビ */}
          <nav className="hidden md:flex items-center space-x-6 mr-16 flex-1 justify-end">
            {navLinks.slice(0, 2).map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="relative text-white/70 hover:text-lp-rose transition-colors duration-300 font-normal text-xs py-2 px-1 group"
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-lp-rose transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
          </nav>

          {/* 中央丸ロゴ */}
          <div className="hidden md:block absolute top-full left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-10">
            <Link to="/lp/academy" className="hover:opacity-80 transition-all duration-200">
              <div className="bg-white rounded-full w-24 h-24 flex flex-col items-center justify-center shadow-sm">
                <img
                  src={`${process.env.PUBLIC_URL}/images/logo.svg`}
                  alt="SrWith"
                  className="h-10 w-auto"
                />
                <span className="text-[9px] font-bold text-gray-600 mt-0.5">アカデミー</span>
              </div>
            </Link>
          </div>

          {/* 右側ナビ */}
          <nav className="hidden md:flex items-center space-x-6 ml-16 flex-1 justify-start">
            {navLinks.slice(2).map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="relative text-white/70 hover:text-lp-rose transition-colors duration-300 font-normal text-xs py-2 px-1 group"
              >
                {link.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-lp-rose transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
            <a
              href="/lp/academy/contact"
              className="bg-lp-rose text-white px-4 py-1.5 rounded-full hover:bg-opacity-90 hover:shadow-md transition-all duration-200 font-medium text-xs ml-2"
            >
              個別相談・お問い合わせ
            </a>
          </nav>

          {/* モバイルロゴ */}
          <div className="md:hidden flex items-center gap-2">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo.svg`}
              alt="SrWith"
              className="h-8 w-auto filter brightness-0 invert"
            />
            <span className="text-[13px] font-bold text-white">アカデミー</span>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="md:hidden absolute right-4 text-white p-1"
            aria-label="メニュー"
          >
            <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {menuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden border-t border-white/10 px-2 pt-3 pb-3 space-y-1 bg-lp-charcoal">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="block px-3 py-2 text-white/70 hover:text-lp-rose hover:bg-white/5 rounded-md font-normal text-sm"
                onClick={() => setMenuOpen(false)}
              >
                {link.label}
              </a>
            ))}
            <a
              href="/contact"
              className="block mx-3 my-3 px-4 py-2 bg-lp-rose text-white hover:bg-opacity-90 rounded-full font-medium text-sm text-center"
              onClick={() => setMenuOpen(false)}
            >
              個別相談・お問い合わせ
            </a>
          </div>
        )}
      </div>
    </header>
  );
};

export default AcademyHeader;
